<template>
	<!-- Tabindex allows the header skip-to-content button to move browser focus here. -->
	<main
		id="main-content"
		class="container mx-auto outline-hidden"
		tabindex="-1"
	>
		<slot></slot>
	</main>
</template>
